export default __webpack_public_path__ + "static/media/home-page.00724ddb.png";